export default "__VITE_ASSET__CWEcVQhi__"